module.exports = __webpack_public_path__ + "img/sum-tv-blue.d692732a.svg";